import { render } from "./AvailabilityModal.vue?vue&type=template&id=3b65df7a&scoped=true"
import script from "./AvailabilityModal.vue?vue&type=script&lang=ts"
export * from "./AvailabilityModal.vue?vue&type=script&lang=ts"

import "./AvailabilityModal.vue?vue&type=style&index=0&id=3b65df7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b65df7a"

export default script